import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import LogicIcon from "../../assets/icons/library_logic.svg2";
import EngineerVisitIcon from "../../assets/icons/engineer.svg2";
import { BroadcastType } from "../store/slices/broadcastSlice";
import { InboundCampaignType } from "../store/inboundCampaignSlice";

export default function InboundCampaignCard({
  template,
  isSelected,
  onSelect,
}: {
  template: InboundCampaignType;
  isSelected: boolean;
  onSelect: () => void;
}) {
  return (
    <div
      key={template.Uuid}
      className={`my-3 ${isSelected ? "" : "opacity-50"}`}
    >
      <button
        type="button"
        className={`btn  w-100 h-100 bg-white p-3 text-start rounded-3 position-relative ${
          isSelected ? "border border-2 border-blue" : ""
        }`}
        onClick={onSelect}
      >
        {isSelected ? (
          <FontAwesomeIcon
            icon={faCheck}
            className="position-absolute top-0 end-0 text-white bg-colored p-2"
            style={{ borderBottomLeftRadius: 8 }}
          />
        ) : null}
        <div className="d-flex align-items-center">
          <div className="bg-purple-gradient rounded-circle me-3">
            <EngineerVisitIcon width={50} />
          </div>
          <div className="flex-grow-1">
            <div className="me-3 d-flex align-items-center justify-content-between">
              <h5 className="text-black fw-bold">{template.Label}</h5>
              <div className="opacity-50">
                <small>#{template.Reference}</small>
              </div>
            </div>
            <div className="text-secondary small">{template.Description}</div>
          </div>
        </div>
      </button>
    </div>
  );
}
